// Angular
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	MatAutocompleteModule,
	MatButtonModule,
	MatCardModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatDialogModule,
	MatIconModule,
	MatInputModule,
	MatMenuModule,
	MatNativeDateModule,
	MatPaginatorModule,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatSelectModule,
	MatSnackBarModule,
	MatSortModule,
	MatTableModule,
	MatTabsModule,
	MatTooltipModule,
} from '@angular/material';
// NgBootstrap
import {NgbDropdownModule, NgbModule, NgbTabsetModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
// Core module
import {CoreModule} from '../../core/core.module';
// CRUD Partials

import {TranslateBooleanPipe} from '../../core/_base/layout'
import {
	ActionNotificationComponent,
	AlertComponent,
	DeleteEntityDialogComponent,
	FetchEntityDialogComponent,
	UpdateStatusDialogComponent,
	SendDataDialogComponent,
} from './content/crud';
// Layout partials
import {
	ContextMenu2Component,
	ContextMenuComponent,
	LanguageSelectorComponent,
	NotificationComponent,
	QuickActionComponent,
	QuickPanelComponent,
	ScrollTopComponent,
	SearchDefaultComponent,
	SearchDropdownComponent,
	SearchResultComponent,
	SplashScreenComponent,
	StickyToolbarComponent,
	Subheader1Component,
	Subheader2Component,
	Subheader3Component,
	Subheader4Component,
	Subheader5Component,
	SubheaderSearchComponent,
	UserProfile2Component,
	UserProfile3Component,
	UserProfileComponent,
} from './layout';
// General
import {NoticeComponent} from './content/general/notice/notice.component';
import {PortletModule} from './content/general/portlet/portlet.module';
// Errpr
import {ErrorComponent} from './content/general/error/error.component';
// Extra module
import {WidgetModule} from './content/widgets/widget.module';
// SVG inline
import {InlineSVGModule} from 'ng-inline-svg';
import {CartComponent} from './layout/topbar/cart/cart.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GaugeChartModule } from 'angular-gauge-chart';
import { Mac1Chart1Component } from './content/charts/line-charts/mac1-chart1/mac1-chart1.component';
import { Mac1Chart2Component } from './content/charts/line-charts/mac1-chart2/mac1-chart2.component';
import { RealtimeMac1Chart1Component } from './content/charts/gauge-charts/realtime-mac1-chart1/realtime-mac1-chart1.component';
import { RealtimeMac1Chart2Component } from './content/charts/gauge-charts/realtime-mac1-chart2/realtime-mac1-chart2.component';
import { RealtimeMac1Chart3Component } from './content/charts/line-charts/realtime-mac1-chart3/realtime-mac1-chart3.component';
import { MacdayMac1Chart1Component } from './content/charts/line-charts/macday-mac1-chart1/macday-mac1-chart1.component';
import { MacdayMac1Chart2Component } from './content/charts/line-charts/macday-mac1-chart2/macday-mac1-chart2.component';
import { CustomTableComponent } from './content/general/custom-table/custom-table.component';
import { SimpleEditComponent } from './content/general/simple-edit/simple-edit.component';
import { SimpleTableComponent } from './content/general/simple-table/simple-table.component';
import { BasicModal } from './content/general/basic-modal/basic-modal.component';
import { ImageInputComponent } from './content/general/image-input/image-input.component';
import { ByteaImageComponent } from './content/general/bytea-image/bytea-image.component';
import { LogoBodyComponent } from './content/general/logo-body/logo-body.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { DateRangeComponent } from './content/general/date-range/date-range.component';
import { StringListInputComponent } from './content/general/string-list-input/string-list-input.component';
import { StringTableinputComponent } from './content/general/string-table-input/string-table-input.component';
import { BreadcrumbsComponent } from './layout/subheader/breadcrumbs/breadcrumbs.component';
import { TableinputComponent } from './content/general/table-input/table-input.component';
import { MachineWidgetComponent } from './content/general/machine-widget/machine-widget.component';
import { SensorH1Component } from './content/general/machine-widget/sensors/sensor-h1/sensor-h1.component';
import { SensorH2Component } from './content/general/machine-widget/sensors/sensor-h2/sensor-h2.component';
import { SensorV1Component } from './content/general/machine-widget/sensors/sensor-v1/sensor-v1.component';
import { CustomGaugeComponent } from './content/charts/gauge-charts/custom-gauge/custom-gauge.component';
import { OnOffComponent } from './content/general/machine-widget/actuators/onoff/onoff.component';
import { ConfirmDialogComponent } from './content/general/confirm-dialog/confirm-dialog.component';
import { ImageGridSelectorComponent } from './content/general/image-grid-selector/image-grid-selector.component';
import { QuantitySelectorComponent } from './content/general/quantity-selector/quantity-selector.component';

@NgModule({
	entryComponents:[
		BasicModal,
		ConfirmDialogComponent
	],
	declarations: [
		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,
		SendDataDialogComponent,

		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		Subheader4Component,
		Subheader5Component,
		SubheaderSearchComponent,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		UserProfile3Component,
		CartComponent,
		TranslateBooleanPipe,
		ErrorComponent,		
		Mac1Chart1Component,
		Mac1Chart2Component,
		RealtimeMac1Chart1Component,
		RealtimeMac1Chart2Component,
		RealtimeMac1Chart3Component,
		MacdayMac1Chart1Component,
		MacdayMac1Chart2Component,
		CustomTableComponent,
		SimpleEditComponent,
		SimpleTableComponent,
		BasicModal,
		ImageInputComponent,
		ByteaImageComponent,
		LogoBodyComponent,
		DateRangeComponent,
		StringListInputComponent,
		StringTableinputComponent,
		TableinputComponent,
		BreadcrumbsComponent,
		MachineWidgetComponent,
		SensorH1Component,
		SensorH2Component,
		SensorV1Component,
		CustomGaugeComponent,
		OnOffComponent,
		ConfirmDialogComponent,
		ImageGridSelectorComponent,
		QuantitySelectorComponent
	],
	exports: [
		WidgetModule,
		PortletModule,
		BasicModal,
		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,
		SendDataDialogComponent,

		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		Subheader4Component,
		Subheader5Component,
		SubheaderSearchComponent,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		UserProfile3Component,
		CartComponent,
		TranslateBooleanPipe,
		ErrorComponent,
		CustomTableComponent,
		SimpleEditComponent,
		SimpleTableComponent,
		ImageInputComponent,
		ByteaImageComponent,
		LogoBodyComponent,
		DateRangeComponent,
		StringListInputComponent,
		StringTableinputComponent,
		BreadcrumbsComponent,
		TableinputComponent,
		SensorH1Component,
		SensorV1Component,
		SensorH2Component,
		MachineWidgetComponent,
		CustomGaugeComponent,
		ConfirmDialogComponent,
		ImageGridSelectorComponent,
		QuantitySelectorComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		PerfectScrollbarModule,
		InlineSVGModule,
		CoreModule,
		PortletModule,
		WidgetModule,

		// angular material modules
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,

		// ng-bootstrap modules
		NgbModule,
		NgbDropdownModule,
		NgbTabsetModule,
		NgbTooltipModule,
		NgxChartsModule,
		GaugeChartModule,
		AngularEditorModule
	],
})
export class PartialsModule {
}
